import { NgModule } from '@angular/core';
import {
  MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
  MatAutocompleteDefaultOptions,
  // eslint-disable-next-line no-restricted-imports
  MatAutocompleteModule
} from '@angular/material/autocomplete';

const defaultOptions: MatAutocompleteDefaultOptions = {
  overlayPanelClass: 'tiime-autocomplete-panel'
};

@NgModule({
  imports: [MatAutocompleteModule],
  exports: [MatAutocompleteModule],
  providers: [{ provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: defaultOptions }]
})
export class TiimeAutocompleteModule {}
